import styles from './locationInfo.module.css';
import ButtonGroup from '../../../components/ButtonGroup';

import baseContext from '../../../store/base_context';
import {useContext, useEffect, useState} from 'react';
import {format} from 'date-fns';
import {utcToZonedTime} from 'date-fns-tz';

const LocationInfo = ({locationInfo}) => {
  const baseCtx = useContext(baseContext);
  const tz = locationInfo?.timezone;
  const currentLocalDatetime = utcToZonedTime(new Date(), tz);

  const currentWeekDay = format(currentLocalDatetime, 'eeee');
  const currentTime = format(currentLocalDatetime, 'HH:mm');
  const currentOpenHours = locationInfo.openHours.find((openHour) =>
    openHour.weekday === currentWeekDay);

  const isOpen = currentOpenHours.isOpen &&
      currentOpenHours.hours.some((hour) =>
        hour.openTime <= currentTime && hour.closeTime >= currentTime
      );

  const openStatus = isOpen ? 'Open' : 'Closed';

  const [isExpand, setIsExpand] = useState(false);

  useEffect(() => {
    if ('socialMedias' in locationInfo) {
      const localSocialMedias = {};
      for (const socialMedia of locationInfo.socialMedias) {
        localSocialMedias[socialMedia.label] = {
          iconClass: socialMedia.iconClass,
          url: socialMedia.url,
        };
      }

      baseCtx.updateFooterSocialMedias(localSocialMedias);
    }
  }, [locationInfo]);

  const fullHours = (
    <>
      <table>
        <tbody>
          {locationInfo.openHours.map((openHour) => (
            <tr key={openHour.weekday}>
              <td>{openHour.weekday}</td>
              <td>
                {openHour.isOpen ?
                      openHour.hours.map((hour) =>
                        hour.openTime12Hour + ' - ' + hour.closeTime12Hour)
                          .join(', ') :
                      'Closed'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );

  const todayHour = (
    <>
      <table>
        <tbody>
          <tr>
            <td>
              <div className={styles.app__location_info_open_status}>
                {openStatus}</div>
            </td>
            <td>
              {currentOpenHours.isOpen &&
                  currentOpenHours.hours.map((hour) =>
                    hour.openTime12Hour + ' - ' + hour.closeTime12Hour)
                      .join(', ')}
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );

  return (
    <div
      className={styles.app__location_info_container}>
      <div
        className={styles.app__location_info_wrapper}
      >
        <div className={styles.app__location_info_content_title}>
          <span>{locationInfo.title}</span>
        </div>
        <div>
          <div className={styles.app__location_info_content_text}>
            <i className={`icon-sc-location2`}/>
            <span>{locationInfo.address}</span>
          </div>
          <div className={styles.app__location_info_content_text}>
            <i className='icon-sc-telephone'/>
            <span>{locationInfo.phoneNum}</span>
          </div>
          <div
            className={`
            ${styles.app__location_info_content_text}
            ${styles.app__location_info_open_hours}`}>
            {isExpand ? fullHours: todayHour}
            <div
              className={`custom__clickable_link 
              ${isExpand && 'custom__reverse_vertical'}`}
              onClick={setIsExpand.bind(0, !isExpand)}>
              <i className={`icon-sc-expand-down`}/>
            </div>
          </div>
          <div className={styles.app__location_info_button_group}>
            <ButtonGroup links={locationInfo.buttons}/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationInfo;
